import MuiLinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";

const LinearProgress: React.FC<LinearProgressProps> = MuiLinearProgress;

export default LinearProgress;
export type { LinearProgressProps };
